import HeaderDrawer from "./HeaderDrawer";
import HeaderUserPopover from "./HeaderUserPopover";
import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { userAvatar } from "../utils";
import { Popover } from 'antd';
import React, { useContext } from 'react';
var HeaderUser = function HeaderUser() {
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var uid = NavigationHeaderContextProps.uid,
    device = NavigationHeaderContextProps.device;
  return /*#__PURE__*/React.createElement("div", null, device === 'pc' ? /*#__PURE__*/React.createElement(Popover, {
    overlayClassName: "dr-nav-popover",
    content: /*#__PURE__*/React.createElement(HeaderUserPopover, null),
    placement: "bottomRight"
  }, /*#__PURE__*/React.createElement("img", {
    className: "dr-nav-avatar",
    src: userAvatar(uid)
  })) : /*#__PURE__*/React.createElement(HeaderDrawer, {
    placement: "right",
    button: /*#__PURE__*/React.createElement("img", {
      className: "dr-nav-avatar",
      src: userAvatar(uid)
    })
  }, /*#__PURE__*/React.createElement(HeaderUserPopover, null)));
};
export default HeaderUser;